<script setup lang="ts">
import BoNoticeDocVarField from './BoNoticeDocVarField.vue';
import BoLetterHead from './parts/BoLetterHead.vue';
import BoLetterClose from './parts/BoLetterClose.vue';
</script>

<template>
  <div class="bo-doc">
    <BoLetterHead recipient-mode="suspected_bo" />
    <p class="doc-p">
      <BoNoticeDocVarField field-key="company_name" />
      (Company Registration No. <BoNoticeDocVarField field-key="company_registration_no" />)
    </p>
    <p class="doc-p">
      Pursuant to subsection 60C(2) of the CA 2016, we know or have reasonable ground to believe that you are the
      beneficial owner of the Company and required to inform and confirm whether or not you are the beneficial owner
      of the Company within 30 days from the date of this notice.
    </p>
    <p class="doc-p">
      <b>2</b><br />
      If your answer in paragraph 1 above is YES, please proceed to Appendix A for your reply.
    </p>
    <p class="doc-p">
      <b>3</b><br />
      If your answer in paragraph 1 above is NO, please proceed to Appendix B for your reply. You are required to
      indicate the persons by name and particulars sufficient to enable those persons to be identified as beneficial
      owner(s) of the Company.
    </p>
    <p class="doc-p"><b>4</b><br />Please include the following declaration as part of your reply:</p>
    <p class="doc-p" style="padding-left:16px; font-style:italic">
      “I hereby confirmed that the facts and information stated in this letter are true and to the best of my knowledge and belief.”
    </p>
    <p class="doc-p">
      <b>5</b><br />
      Please be informed that any person who fails to comply with this notice commits an offence under subsection
      60C(7) of the CA 2016 and/or provides false or misleading information commits an offence under section 593 of
      the CA 2016.
    </p>
    <BoLetterClose var-key="BO03" designation-key="signer_designation_BO03" />
  </div>
</template>

<style src="./boNoticeDoc.css"></style>
